import React from 'react';
import { cn } from '../lib/utils';
import { Card, CardContent } from './Card';

/**
 * Metronic WelcomeCard - For welcome messages, tips, and announcements
 * Perfect for onboarding, feature highlights, tips
 *
 * @param {string} title - Card title
 * @param {string} message - Main message
 * @param {string} tip - Optional tip text
 * @param {string} emoji - Optional emoji
 * @param {string} variant - Color variant (info, success, warning)
 * @param {React.ReactNode} actions - Optional action buttons
 * @param {string} className - Additional classes
 */
const WelcomeCard = ({
  title,
  message,
  tip,
  emoji = '💡',
  variant = 'info',
  actions,
  className
}) => {
  const variants = {
    info: {
      bg: 'bg-blue-50 dark:bg-blue-900/10',
      border: 'border-blue-200 dark:border-blue-800',
      title: 'text-blue-900 dark:text-blue-100',
      text: 'text-blue-800 dark:text-blue-200',
    },
    success: {
      bg: 'bg-green-50 dark:bg-green-900/10',
      border: 'border-green-200 dark:border-green-800',
      title: 'text-green-900 dark:text-green-100',
      text: 'text-green-800 dark:text-green-200',
    },
    warning: {
      bg: 'bg-orange-50 dark:bg-orange-900/10',
      border: 'border-orange-200 dark:border-orange-800',
      title: 'text-orange-900 dark:text-orange-100',
      text: 'text-orange-800 dark:text-orange-200',
    },
  };

  const colors = variants[variant];

  return (
    <Card className={cn("border", colors.border, colors.bg, className)}>
      <CardContent className="p-6">
        {title && (
          <h2 className={cn("text-lg font-semibold mb-3", colors.title)}>
            {title}
          </h2>
        )}

        {message && (
          <p className={cn("text-sm mb-4", colors.text)}>
            {message}
          </p>
        )}

        {tip && (
          <div className="flex items-start gap-2 text-sm">
            <span className="text-lg">{emoji}</span>
            <span className={colors.text}>
              <span className="font-medium">Tip:</span> {tip}
            </span>
          </div>
        )}

        {actions && (
          <div className="mt-4 flex items-center gap-3">
            {actions}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default WelcomeCard;

